import { debug_disable_reload } from "./debug";
export const export_api_functions = (config) => {
    window.PlaceholderPlugin = {
        "settings": config.settings,
        "placeholders": config.placeholders,
        "debug_disable_reload": debug_disable_reload,
        "debug_print_dependency_graph": () => config.dependency_graph.debug_print_representation(),
    };
};
